module.exports = __webpack_public_path__ + "static/media/nav-logo.63385d78.png";